import { render, staticRenderFns } from "./RemoverDestinatario.vue?vue&type=template&id=c989aefe&scoped=true&"
import script from "./RemoverDestinatario.vue?vue&type=script&lang=js&"
export * from "./RemoverDestinatario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c989aefe",
  null
  
)

export default component.exports